var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOds = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30.4,
  height: 36,
  x: 8.6,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M8.6 29H39v7a2 2 0 0 1-2 2H10.6a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M29.88 29V2H37a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 30.4,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#1859A9",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.87 24.93q-.77 0-1.39-.25a3 3 0 0 1-1.05-.74 3.3 3.3 0 0 1-.68-1.17 5 5 0 0 1-.23-1.58q0-.88.24-1.58t.68-1.18a2.8 2.8 0 0 1 1.06-.74 3.5 3.5 0 0 1 1.37-.26q.76 0 1.38.26.62.25 1.05.73t.66 1.18q.24.69.24 1.57 0 .89-.23 1.59-.23.69-.66 1.18a2.9 2.9 0 0 1-1.05.74q-.61.25-1.39.25m-.01-1.04q1.03 0 1.56-.72.53-.73.53-1.99 0-.63-.14-1.13a2.4 2.4 0 0 0-.39-.85 1.76 1.76 0 0 0-.65-.54 2.05 2.05 0 0 0-.91-.19q-.52 0-.91.19c-.39.19-.48.307-.66.54a2.4 2.4 0 0 0-.39.85q-.13.5-.13 1.13 0 1.26.52 1.99.53.72 1.57.72m7.005-.17q.63 0 1.07-.18.45-.18.73-.52a2.1 2.1 0 0 0 .42-.81q.13-.47.13-1.06 0-1.18-.5-1.84-.5-.67-1.64-.67h-1.38v5.08zm.2-6.11q.79 0 1.42.22a2.7 2.7 0 0 1 1.07.65q.44.44.67 1.11.24.66.24 1.55t-.25 1.57a3.05 3.05 0 0 1-.72 1.13 3.05 3.05 0 0 1-1.15.68q-.67.23-1.52.23h-2.34v-7.14zm5.465 4.96q.08.7.5 1.02.43.32 1.27.32.411 0 .69-.09.28-.09.45-.24a.8.8 0 0 0 .24-.35q.07-.21.07-.44 0-.17-.05-.33a.8.8 0 0 0-.18-.31 1.1 1.1 0 0 0-.35-.24 2 2 0 0 0-.56-.17l-.91-.17a6 6 0 0 1-.96-.25 2.3 2.3 0 0 1-.71-.39 1.7 1.7 0 0 1-.43-.6q-.14-.36-.14-.87t.2-.89q.21-.38.57-.63.36-.26.85-.38a4.3 4.3 0 0 1 1.08-.13q.74 0 1.24.17.501.17.81.45.31.27.47.63t.22.75l-1.14.18q-.14-.6-.49-.89-.34-.29-1.09-.29-.429 0-.72.08a1.2 1.2 0 0 0-.46.21.8.8 0 0 0-.25.31.9.9 0 0 0-.07.36q0 .47.25.7.261.23.9.36l.99.19q1.13.21 1.66.72.53.5.53 1.45 0 .45-.17.84a1.8 1.8 0 0 1-.5.67 2.5 2.5 0 0 1-.85.44 3.6 3.6 0 0 1-1.17.17q-1.37 0-2.15-.57-.78-.58-.86-1.79z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOds);
export default ForwardRef;